import * as React from 'react';
import { PropsWithChildren } from 'react';
import { LoadingTable } from './LoadingTable';

export type LoadingContentTableProps = {
    loading: boolean,
    classes: string,
    colspan: number,
}

export const LoadingTableContent: React.FC<PropsWithChildren<LoadingContentTableProps>> = (props) => {
    return (<>{props.loading ? <LoadingTable colspan={props.colspan} classes={props.classes} /> : props.children}</>);
};
